import React from "react";
import {
  Form,
  Dropdown,
  Button,
  Confirm,
  Segment,
  Header,
  Message,
  Icon,
  Grid,
  Transition
} from "semantic-ui-react";
import SyncLoader from "./SyncLoader";

const getRemovingHotels = (selected, hotels) => {
  const hotelToRemove = hotels.filter(
    hotel =>
      !selected.find(
        selectedHotel =>
          hotel.hotelMapping.hotelMapId === parseInt(selectedHotel.id, 10)
      )
  );
  return hotelToRemove.map(hotel => hotel.hotelName.toUpperCase());
};
export class SynchronizationLogin extends React.Component {
  state = {
    open: false
  };
  open = () => this.setState({ open: true });
  close = () => this.setState({ open: false });
  confirm = () => {
    this.close();
    this.props.synchronize();
  };

  componentDidUpdate(prevProps) {
    if (prevProps.hotels.length === 0 && this.props.hotels.length > 0) {
      this.props.selectHotel(
        this.props.syncedHotels.map(hotel =>
          hotel.hotelMapping.hotelMapId.toString()
        )
      );
    }
  }
  render() {
    const {
      hotels,
      selected,
      authenticate,
      synchronize,
      username,
      password,
      setLogin,
      setPassword,
      selectHotel,
      syncedHotels,
      t,
      fetching,
      synchronizationInfoMessageVisible,
      toggleMessage,
      isSynchronizing
    } = this.props;
    const hotelsToRemove = getRemovingHotels(selected, syncedHotels);
    return (
      <div>
        {synchronizationInfoMessageVisible && (
          <Message
            info
            icon
            onDismiss={() => toggleMessage("synchronizationInfoMessage")}>
            <Icon name="help" />
            <Message.Content>
              <Message.Header>Info</Message.Header>
              {t("synchronization:synchronizationMessageText")}
            </Message.Content>
          </Message>
        )}
        {!isSynchronizing && (
          <Message warning icon>
            <Icon name="warning" />
            <Message.Content>
              <Message.Header>
                {`${t("common:warningHeaderText")}!`}!
              </Message.Header>
              {t("synchronization:synchronizationWarningText")}
            </Message.Content>
          </Message>
        )}
        <Grid columns="equal">
          <Grid.Column>
            <Header as="h1">{t("synchronization:synchronizationText")}</Header>
          </Grid.Column>
          <Grid.Column textAlign="right">
            {!synchronizationInfoMessageVisible && (
              <Button
                icon
                onClick={() => {
                  toggleMessage("synchronizationInfoMessage");
                }}
                style={{ backgroundColor: "#5a697b" }}>
                <Icon name="help" style={{ color: "white" }} />
              </Button>
            )}
          </Grid.Column>
        </Grid>
        <Confirm
          cancelButton={t("common:noText")}
          confirmButton={t("common:yesText")}
          open={this.state.open}
          header={t("synchronization:warningHeaderText")}
          content={t("synchronization:warningText", {
            hotels: hotelsToRemove.join(", ")
          })}
          onCancel={this.close}
          onConfirm={this.confirm}
        />
        {fetching && <SyncLoader />}
        <Segment loading={fetching}>
          <Form>
            <Form.Input
              label={t("synchronization:usernameText")}
              placeholder={t("synchronization:usernameText")}
              value={username}
              onChange={e => setLogin(e.target.value)}
            />
            <Form.Input
              label={t("synchronization:passwordText")}
              placeholder={t("synchronization:passwordText")}
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
            {hotels.length > 0 && (
              <Form.Field>
                <label>{t("synchronization:hotelsText")}</label>
                <Dropdown
                  fluid
                  placeholder={t("synchronization:hotelsText")}
                  multiple
                  search
                  selection
                  value={selected.map(hotel => hotel.id)}
                  onChange={(e, a) => selectHotel(a.value)}
                  options={hotels.map(hotel => ({
                    value: hotel.id,
                    text: hotel.name
                  }))}
                />
              </Form.Field>
            )}
            {hotels.length === 0 && (
              <Button color="blue" onClick={authenticate}>
                {t("synchronization:loginButton")}
              </Button>
            )}
            {hotels.length > 0 && (
              <Button
                onClick={() => {
                  hotelsToRemove.length > 0 ? this.open() : synchronize();
                }}
                color="orange">
                {t("synchronization:synchronizeButton")}
              </Button>
            )}
          </Form>
        </Segment>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/synchronization/Synchronization.js